// @avantia common-code
import { SMap } from '@avantia/client-and-server-utilities';
import { AddonTypesRecord } from '../tools/utilities';

export type HpPoliciesState = PolicyMap;

export type PolicyMap = SMap<Policy>;

export interface PolicyInstancesCustomData {
  noPoliciesText: string;
  questionText: string;
  productNamesMap: SMap<string>;
}

export interface CoverType {
  Buildings: null;
  BuildingsAndContents?: null;
  Contents: null;
}

export interface AccidentalDamageLevel {
  Basic: null;
  Full: null;
  None: null;
}

export type AccidentalDamageLevelCoverMap = { [key in keyof CoverType]: string };

export type HpProductDescriptionTypes = 'Evan' | 'Florence';

export interface Policy {
  accidentalDamageLevel: AccidentalDamageLevelCoverMap;
  addonDetails: AddonDetails;
  additionalPolicyHolders: JointPolicyHolder[];
  altPhoneNumber: string;
  buildingsSumInsured: number;
  claims: PreviousClaim[];
  contentsSumInsured: number;
  county: string;
  coverType: string;
  dateOfBirth: Date;
  endDate: string;
  endorsements: Endorsement[];
  exBuildingAD: boolean;
  exContentsAD: boolean;
  exFlood: boolean;
  excesses: Excesses;
  exSubs: boolean;
  forename: string;
  hasUnoccupiedExtendedPerils: boolean;
  historyId: number;
  house: string;
  inceptionDate: string;
  isFleea: boolean;
  isFloodRe: boolean;
  isUnoccupied: boolean;
  locality: string;
  outbuildingsSumInsured: number;
  personalPossessionsSumInsured: number;
  phoneNumber: string;
  policyDetailsId: string;
  policyNumber: string;
  postcode: string;
  productDescription: HpProductDescriptionTypes;
  specifiedItems: SpecifiedItem[];
  startDate: string;
  street: string;
  surname: string;
  title: string;
}

export type AvailableAddons = { [key in keyof AddonTypesRecord]: Addon };

export interface AddonDetails {
  availableAddons: { [key in keyof AddonTypesRecord]: Addon };
  addons: Addon[];
}

export interface Excesses {
  compulsoryExcesses: Excess[];
  voluntaryExcesses: Excess[];
}

export interface Excess {
  amount: number;
  description: string;
  order: number;
}

export interface SpecifiedItem {
  amount: number;
  category: string;
  isAwayFromHomeCover: boolean;
  description: string;
}

export interface Endorsement {
  code: string;
  description: string;
  name: string;
  order: number;
}

export interface Addon {
  claimsNumber: string;
  code: string;
  description: string;
  hasHomeEmergency: boolean;
  hasKeyProtect: boolean;
  hasLegalExpenses: boolean;
  hasRentGuarantee: boolean;
  name: string;
  order: number;
}

export interface JointPolicyHolder {
  title: string;
  forename: string;
  surname: string;
  dateOfBirth: string;
}

export interface PreviousClaim {
  claimDate: Date;
  claimTypeDescription: string;
  claimNumber: string;
  claimAmount: number;
  claimSection: string;
  claimOutstanding: boolean;
  claimAtProperty: boolean;
}

export interface CustomerDetails {
  emailAddress: string;
  postcode?: string;
}

export type AddonType = 'HE' | 'LE' | 'LK';

export const notListedSpecifiedItem = 'notListed';

export interface PerilType {
  EOW: string;
  AccidentalDamage: string;
  Storm: string;
  AccidentalLoss: string;
  Theft: string;
  Other: string;
}

//TODO : Create script that generates maps and interfaces out of question set lookup.
export const perilTypeMap: { [key in keyof PerilType]: keyof PerilType } = {
  EOW: 'EOW',
  AccidentalDamage: 'AccidentalDamage',
  Storm: 'Storm',
  AccidentalLoss: 'AccidentalLoss',
  Theft: 'Theft',
  Other: 'Other'
};

/** Flood is not a perilType tile. It is reached by answering perilType 'Other' and then this otherReason option. */
export const floodOtherReasonKey = 'Flood';

export type DamagedItemsTypes =
  | 'laptop'
  | 'bicycle'
  | 'mobilePhone'
  | 'otherElectronicGadget'
  | 'watch'
  | 'jewellery'
  | 'somethingElse'
  | 'antiques'
  | 'artworks'
  | 'rareBooks'
  | 'china'
  | 'clocks'
  | 'coins'
  | 'wheelchair'
  | 'furs'
  | 'glassware'
  | 'goldOrSilver'
  | 'guns'
  | 'handbags'
  | 'medals'
  | 'medicalEquip'
  | 'musicalEquip'
  | 'porcelain'
  | 'sportsEquip'
  | 'stamp'
  | 'other';

export const gadgets: DamagedItemsTypes[] = ['laptop', 'bicycle', 'mobilePhone', 'otherElectronicGadget'];
export const tvOrDesktopComputer = ['TV', 'desktopComputer'];
export const highRiskItems: DamagedItemsTypes[] = [
  'antiques',
  'artworks',
  'rareBooks',
  'china',
  'clocks',
  'coins',
  'wheelchair',
  'furs',
  'glassware',
  'goldOrSilver',
  'guns',
  'handbags',
  'medals',
  'medicalEquip',
  'musicalEquip',
  'porcelain',
  'sportsEquip',
  'stamp'
];
export const notPersonalPossession: DamagedItemsTypes[] = [
  'antiques',
  'artworks',
  'rareBooks',
  'china',
  'clocks',
  'coins',
  'glassware',
  'goldOrSilver',
  'guns',
  'medals',
  'porcelain',
  'sportsEquip',
  'stamp'
];

export const somethingElse: DamagedItemsTypes = 'somethingElse';
export const isJewelleryOrWatch: DamagedItemsTypes[] = ['jewellery', 'watch'];
export const other: DamagedItemsTypes = 'other';
